import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import analytics from '../../utils/analytics';
import type { BNPLRegisterPreApproveResponse } from '../../queries/bnpl';
import BancameWidget from '../../components/BancameWidget';
import BancameAlert from '../../components/Alert';

const RESULT_SCREEN_MIN_HEIGHT = 260;

type CreditLineScreenProps = {
  evaluationResponse: BNPLRegisterPreApproveResponse['data'],
};

export default function CreditLineScreen({
  evaluationResponse,
}: CreditLineScreenProps) {
  const formattedCreditLine = new Intl.NumberFormat('es-CL').format(evaluationResponse.maxApprovedAmount);
  const [openWidget, setOpenWidget] = React.useState(false);
  const [registrationComplete, setRegistrationComplete] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState('Ha ocurrido un error, por favor contáctanos');
  const [restartWidget, setRestartWidget] = React.useState(false);
  React.useEffect(() => {
    analytics.page(
      'BNPL - REGISTRO',
      evaluationResponse.isRegistered ? 'LINEA DE CREDITO  - CON SUBSCRIPCION'
        : 'LINEA DE CREDITO  - SIN SUBSCRIPCION',
    );
  }, []);

  const handleSuccess = () => {
    setRegistrationComplete(true);
    window.location.href = 'https://www.banca.me/personas/cuotas-sin-tarjeta';
  };

  const handleReject = (event: 'reject_callback' | 'error_callback') => {
    if (event === 'error_callback') {
      setAlertMessage('Ha ocurrido un error, porfavor intenta nuevamente.');
      setRestartWidget(true);
    } else {
      setAlertMessage('Ha ocurrido un error, por favor contáctanos');
    }
    return setOpenAlert(true);
  };

  return (
    <Box
      sx={{
        minHeight: RESULT_SCREEN_MIN_HEIGHT,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="body1"
          align="center"
          sx={{
            opacity: 0.5,
            marginBottom: 1,
            fontWeight: 700,
          }}
        >
          ¡Felicidades! 🎉
        </Typography>
        <Typography
          variant="body1"
          align="center"
          sx={{
            marginBottom: 1,
            fontWeight: 700,
            fontSize: 16,

          }}
        >
          Tu
          {' '}
          <b>poder de compra</b>
          {' '}
          disponible para pagar en cuotas sin tarjetas es de:
        </Typography>
        <Typography
          fontSize={50}
          align="center"
          color="primary"
          sx={{
            fontWeight: 700,
            padding: 2,
          }}
        >
          $
          {formattedCreditLine}
        </Typography>
      </Box>
      <div style={{ textAlign: 'center' }}>
        {(evaluationResponse.isRegistered || registrationComplete) ? (
          <Button
            type="button"
            variant="contained"
            color="primary"
            fullWidth
            href="https://www.banca.me/personas/cuotas-sin-tarjeta"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ir a comprar
          </Button>
        ) : (
          <Button
            onClick={() => setOpenWidget(true)}
            type="button"
            variant="contained"
            color="primary"
            fullWidth
          >
            Continuar registro
          </Button>
        )}
      </div>
      <BancameAlert
        successMessage=""
        errorMessage={alertMessage}
        openAlert={openAlert}
        error
      />
      {openWidget && (
      <BancameWidget
        widgetToken={evaluationResponse.widgetToken}
        publicKey={evaluationResponse.publicKey}
        onSuccess={handleSuccess}
        onReject={handleReject}
        restartWidget={restartWidget}
      />
      )}
    </Box>
  );
}
